import { MAX_UPLOAD_SIZE_BYTES } from '~constants/common';
import { validFileTypes } from '~constants/files';

export const validateFile = (file: File): string | true => {
  if (!file) {
    return 'No file selected';
  }

  const { type, size, name } = file;
  const fileExtension = name.split('.').pop()?.toLowerCase();
  if (!fileExtension) {
    return 'File must have an extension';
  }

  // Check extension type
  const isExtensionValid = validFileTypes.some((fileType) => fileType.extension.toLowerCase() === `.${fileExtension}`);
  if (!isExtensionValid) {
    return `Invalid file extension: .${fileExtension}. Allowed extensions are: ${validFileTypes
      .map((fileType) => fileType.extension)
      .join(', ')}`;
  }

  // Check MIME Type
  const isMimeTypeValid = validFileTypes.some((fileType) => fileType.mimeType === type);
  if (!isMimeTypeValid) {
    return `Invalid file format. File appears to be ${type} which is not allowed. Allowed formats are: ${validFileTypes
      .map((fileType) => fileType.extension)
      .join(', ')}`;
  }

  // Check Upload Size
  if (size > MAX_UPLOAD_SIZE_BYTES) {
    return `File size exceeds the limit of ${MAX_UPLOAD_SIZE_BYTES / (1024 * 1024)} MB`;
  }

  return true; // File is valid
};
